import React, { createContext, useState, useEffect, useContext } from "react";

// Create context
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for user on initial load
  useEffect(() => {
    const checkUserLoggedIn = () => {
      const storedUser = localStorage.getItem("BricksNbar-Users-Data");
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          if (parsedUser._id) {
            setUser(parsedUser);
          }
        } catch (err) {
          console.error("Error parsing user data from localStorage:", err);
        }
      }
      setLoading(false);
    };

    checkUserLoggedIn();
  }, []);

  // Login function
  const login = (userData, token) => {
    localStorage.setItem("BricksNbar-Users-Data", JSON.stringify(userData));
    if (token) {
      localStorage.setItem("BricksNbar-authToken", token);
    }
    setUser(userData);
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("BricksNbar-Users-Data");
    localStorage.removeItem("BricksNbar-authToken");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
